import getLocalString from "constants/Localization";
import { useGetReportSalesByProposalSourceMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportSalesByProposalSource = (showSuccessMessage: boolean = true) => {
  const [mutation, { loading, data, error }] = useGetReportSalesByProposalSourceMutation();
  const [getReportSalesByProposalSource, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportSalesByProposalSource",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportSalesByProposalSource, { ...context, data }] as const;
};

export default useGetReportSalesByProposalSource;
